import React, { useEffect, useState } from 'react'
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'
import axios from 'axios'
import BreadCrumb from '../BreadCrumb/BreadCrumb'
import ByCommodity from '../ByCommodity/ByCommodity'
import DashboardTables from '../DashboardTables/DashboardTables'
import DashboardNotes from '../DashboardNotes/DashboardNotes'
import PrintButton from '../PrintButton/PrintButton';

export default function CountyOverview(props) {
    const { countyName, countyKey } = props

    const [countyData, setCountyData] = useState()
    const [countyDataLoaded, setCountyDataLoaded] = useState(false)
    const [countyImports, setCountyImports] = useState()
    const [countyExports, setCountyExports] = useState()
    const [countyExportsLoaded, setCountyExportsLoaded] = useState()
    const [countyImportsLoaded, setCountyImportsLoaded] = useState(false)
    const [commodityTotal, setCommodityTotal] = useState()
    const [commodityTotalLoaded, setCommodityTotalLoaded] = useState(false)

    useEffect(() => {
        (() => {
            axios.get(`/wp-json/county/v1?url_key=${countyKey}`)
            .then(res => res.data)
            .then(data => {
                setCountyData(data[0])
                setCountyDataLoaded(true)
            })
            .catch(e => console.log(e))
        })();
        (() => {
            axios.get(`/wp-json/commoditybycounty/v1?url_key=${countyKey}&sort_by=ImportSTONS&sort_dir=DESC&page=1&limit=5`)
            .then(res => res.data)
            .then(data => {
                let arr = []
                const top5 = Object.entries(data).slice(0, -2).slice(0, 5).map(entry => entry[1])
                    if (top5) {
                        top5.forEach((value) => {
                            arr.push({
                                name: value.CommodityName,
                                importSTONS: value.ImportSTONS
                            })
                        })
                    }
                setCountyImports(arr)
                setCountyImportsLoaded(true)
            })
            .catch(e => console.log(e))
        })();
        (() => {
            axios.get(`/wp-json/commoditybycounty/v1?url_key=${countyKey}`)
            .then(res => res.data)
            .then(data => {
                const commodityTotal = data.total
                setCommodityTotal(commodityTotal)
                setCommodityTotalLoaded(true)
            })
            .catch(e => console.log(e))
        })();
        (() => {
            axios.get(`/wp-json/commoditybycounty/v1?url_key=${countyKey}&sort_by=ExportSTONS&sort_dir=DESC&page=1&limit=5`)
            .then(res => res.data)
            .then(data => {
                let arr = []
                const top5 = Object.entries(data).slice(0, 5).map(entry => entry[1])
                    if (top5) {
                        top5.forEach((value) => {
                            arr.push({
                                name: value.CommodityName,
                                exportSTONS: value.ExportSTONS
                            })
                        })
                    }
                setCountyExports(arr)
                setCountyExportsLoaded(true)
            })
            .catch(e => console.log(e))
        })();
    }, [countyKey])

    return (
        <>
            <BreadCrumb isCounty={true} countyName={countyName} regionName={countyData?.RegionName} regionUrlKey={countyData?.RegionUrlKey}/>

            <h1>{countyName}</h1>

            <Tabs>
                <TabList>
                    <Tab>Overview</Tab>
                    <Tab>By Commodity {commodityTotalLoaded ? `(${commodityTotal})` : null}</Tab>
                </TabList>
                <TabPanel>
                    <PrintButton />
                    <DashboardTables apiData={countyData} 
                    apiLoaded={countyDataLoaded}
                    importData={countyImports}
                    exportData={countyExports}
                    importLoaded={countyImportsLoaded}
                    exportLoaded={countyExportsLoaded}
                    showCharts={true}/>
                </TabPanel>
                <TabPanel>
                    <ByCommodity countyKey={countyKey}/>
                </TabPanel>
            </Tabs>
            <DashboardNotes />
        </>
    )
}